export const checkPassword = (password: string) => {
  const validLength = password.length >= 8;
  const hasUppercase = password.toLowerCase() !== password;
  const hasLowercase = password.toUpperCase() !== password;
  const specialChar = /[!#$%&+?_@~-]/u.test(password);

  return validLength && hasUppercase && hasLowercase && specialChar;
};
